var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C4.44772 2 4 2.44772 4 3V5.00001H20V3C20 2.44772 19.5523 2 19 2H5ZM19.7822 7.00001H4.21776C4.3321 7.22455 4.48907 7.42794 4.68299 7.59762L10.683 12.8476C11.437 13.5074 12.563 13.5074 13.317 12.8476L19.317 7.59762C19.5109 7.42794 19.6679 7.22455 19.7822 7.00001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.7049L14 10H10V18.7049L14 16.7049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.7e9b898003f3c324ff41b0c01e0a4314.svg";
export { ForwardRef as ReactComponent };